import Vue from 'vue'
import Viewer from 'v-viewer'
import * as spreadsheet from '../spreadsheet'
// import * as beMonitor from '../beMonitor'
// import * as statistics from '../statistics'
import * as misc from '../misc'
import * as radish from '../radish'
// import * as project from '../project'
// import * as company from '../company'
import { UploadDialog } from '../file'
import '../file/statics/css/viewer.css'

// TODO 整理index.js里不需要全局注册的组件
const registerComponents = () => {
  Vue.component('UploadDialog', UploadDialog)
  Vue.use(Viewer, { defaultOptions: { zIndex: 9998 } })

  Object.keys(spreadsheet).forEach(name => {
    Vue.component(name, spreadsheet[name])
  })

  // Object.keys(beMonitor).forEach(name => {
  //   Vue.component(name, beMonitor[name])
  // })

  // Object.keys(statistics).forEach(name => {
  //   Vue.component(name, statistics[name])
  // })

  Object.keys(misc).forEach(name => {
    Vue.component(name, misc[name])
  })

  Object.keys(radish).forEach(name => {
    Vue.component(name, radish[name])
  })

  // Object.keys(project).forEach(name => {
  //   Vue.component(name, project[name])
  // })

  // Object.keys(company).forEach(name => {
  //   Vue.component(name, company[name])
  // })

  // Object.keys(file).forEach(name => {
  //   Vue.component(name, file[name])
  // })
}

export default registerComponents
